// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__3_5pY","focado":"OptionSelect_focado__2T328"};